// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file common/notification.proto (package common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/notification.proto.
 */
export const file_common_notification: GenFile = /*@__PURE__*/
  fileDesc("Chljb21tb24vbm90aWZpY2F0aW9uLnByb3RvEgZjb21tb24ijQIKE05vdGlmaWNhdGlvbk1lc3NhZ2USCgoCaWQYASABKAkSJgoEdHlwZRgCIAEoDjIYLmNvbW1vbi5Ob3RpZmljYXRpb25UeXBlEjMKC2VudGl0eV90eXBlGAMgASgOMh4uY29tbW9uLk5vdGlmaWNhdGlvbkVudGl0eVR5cGUSFgoJZW50aXR5X2lkGAQgASgJSACIAQESFAoHcGF5bG9hZBgFIAEoCUgBiAEBEg8KB2lzX3JlYWQYBiABKAgSFAoHcmVhZF9hdBgHIAEoCUgCiAEBEhIKCmNyZWF0ZWRfYXQYCCABKAlCDAoKX2VudGl0eV9pZEIKCghfcGF5bG9hZEIKCghfcmVhZF9hdCpeChBOb3RpZmljYXRpb25UeXBlEiEKHU5PVElGSUNBVElPTl9UWVBFX1VOU1BFQ0lGSUVEEAASJwojTk9USUZJQ0FUSU9OX1RZUEVfREVQT1NJVF9TVUNDRUVERUQQASpmChZOb3RpZmljYXRpb25FbnRpdHlUeXBlEigKJE5PVElGSUNBVElPTl9FTlRJVFlfVFlQRV9VTlNQRUNJRklFRBAAEiIKHk5PVElGSUNBVElPTl9FTlRJVFlfVFlQRV9PUkRFUhABYgZwcm90bzM");

/**
 * @generated from message common.NotificationMessage
 */
export type NotificationMessage = Message<"common.NotificationMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.NotificationType type = 2;
   */
  type: NotificationType;

  /**
   * @generated from field: common.NotificationEntityType entity_type = 3;
   */
  entityType: NotificationEntityType;

  /**
   * Id of the related entity (e.g. the deposit order id). Used by the client
   * for deep-links ("More details").
   *
   * @generated from field: optional string entity_id = 4;
   */
  entityId?: string;

  /**
   * Display snapshot captured at creation time so the list renders without a
   * per-item lookup, JSON-encoded to stay generic across notification kinds.
   * For deposits: {"amount","currency","method","displayId"}.
   *
   * @generated from field: optional string payload = 5;
   */
  payload?: string;

  /**
   * @generated from field: bool is_read = 6;
   */
  isRead: boolean;

  /**
   * @generated from field: optional string read_at = 7;
   */
  readAt?: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;
};

/**
 * Describes the message common.NotificationMessage.
 * Use `create(NotificationMessageSchema)` to create a new message.
 */
export const NotificationMessageSchema: GenMessage<NotificationMessage> = /*@__PURE__*/
  messageDesc(file_common_notification, 0);

/**
 * Generic notification kinds. Deposits are the first concrete case; new kinds
 * (withdrawals, KYC, bonuses, …) are added here without schema changes.
 *
 * @generated from enum common.NotificationType
 */
export enum NotificationType {
  /**
   * @generated from enum value: NOTIFICATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_DEPOSIT_SUCCEEDED = 1;
   */
  DEPOSIT_SUCCEEDED = 1,
}

/**
 * Describes the enum common.NotificationType.
 */
export const NotificationTypeSchema: GenEnum<NotificationType> = /*@__PURE__*/
  enumDesc(file_common_notification, 0);

/**
 * What domain entity a notification points at. Combined with `entity_id` this
 * is the polymorphic relation that keeps the table generic.
 *
 * @generated from enum common.NotificationEntityType
 */
export enum NotificationEntityType {
  /**
   * @generated from enum value: NOTIFICATION_ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_ENTITY_TYPE_ORDER = 1;
   */
  ORDER = 1,
}

/**
 * Describes the enum common.NotificationEntityType.
 */
export const NotificationEntityTypeSchema: GenEnum<NotificationEntityType> = /*@__PURE__*/
  enumDesc(file_common_notification, 1);

